import type { LightingManager } from '../lighting-manager.class';

/**
 * Dispose of all lights
 */
export const disposeCfn = (self: LightingManager, _params: Record<string, never>): void => {
	const config = self.internalConfig;
	const { scene } = config;

	const ambientLight = self.internalAmbientLight;
	if (ambientLight) {
		scene.remove(ambientLight);
		ambientLight.dispose();
		self.internalAmbientLight = null;
	}

	const directionalLight = self.internalDirectionalLight;
	if (directionalLight) {
		scene.remove(directionalLight);
		scene.remove(directionalLight.target);
		directionalLight.dispose();
		self.internalDirectionalLight = null;
	}

	const hemisphereLight = self.internalHemisphereLight;
	if (hemisphereLight) {
		scene.remove(hemisphereLight);
		hemisphereLight.dispose();
		self.internalHemisphereLight = null;
	}

	const highlightSpotLight = self.internalHighlightSpotLight;
	if (highlightSpotLight) {
		scene.remove(highlightSpotLight);
		scene.remove(highlightSpotLight.target);
		highlightSpotLight.dispose();
		self.internalHighlightSpotLight = null;
	}
};
